import enterView from 'enter-view'
import WebFont from 'webfontloader'
import MoveTo from 'moveto'
import imagesLoaded from 'imagesloaded'

import Analytics from 'analytics'
import googleTagManager from '@analytics/google-tag-manager'

export default {
  init() {
    WebFont.load({
      google: {
        families: [
          'Prompt:200,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i&display=swap&subset=thai',
        ],
      },
    })

    const analytics = Analytics({
      app: 'awesome-app',
      plugins: [
        googleTagManager({
          containerId: 'GTM-TD6MH5S',
        }),
      ],
    })

    analytics.page()
    // const aboutForm = document.querySelector('.form-about')
    // const aboutSection = aboutForm.querySelector('input')
    // const aboutMenus = document.querySelectorAll('.megamenu-about li a')
    const buttonCookies = document.querySelector('.cookies-setting')
    const navigation = document.querySelector('.site-navigation')
    const button = document.querySelector('#button')
    const megamenu = document.querySelector('.megamenu')
    const vh = window.innerHeight * 0.01
    megamenu.style.setProperty('--vh', `${vh}px`)

    buttonCookies.addEventListener('click', (event) => {
      event.preventDefault()
      // function OptanonWrapper() {}
    })

    button.addEventListener('click', (event) => {
      event.preventDefault()
      document.body.classList.toggle('open-menu')
    })

    navigation.addEventListener('mouseover', (event) => {
      document.body.classList.add('hover-navigation')
      document.body.classList.remove('open-menu')
    })

    const certificate = navigation.querySelector('li.certificate')
    const navigationDropdown = document.querySelector(
      '.site-navigation-dropdown'
    )

    certificate.addEventListener('mouseover', (event) => {
      navigationDropdown.classList.add('hide')
    })

    certificate.addEventListener('mouseout', (event) => {
      navigationDropdown.classList.remove('hide')
    })

    navigation.addEventListener('mouseout', (event) => {
      document.body.classList.remove('hover-navigation')
    })

    window.addEventListener('resize', () => {
      const vh = window.innerHeight * 0.01
      megamenu.style.setProperty('--vh', `${vh}px`)
    })

    const headerMenu = document.querySelector('.header-menu.scrollspy')
    if (headerMenu) {
      imagesLoaded(document.body, (instance) => {
        const moveTo = new MoveTo({
          tolerance: 110,
          duration: 800,
        })

        const sections = document.querySelectorAll('.main-content section')
        const menuLinks = document.querySelectorAll('.header-menu a')

        for (let i = 0; i < menuLinks.length; i++) {
          moveTo.registerTrigger(menuLinks[i])
        }

        const makeActive = (link) => menuLinks[link].classList.add('is-active')
        const removeActive = (link) =>
          menuLinks[link].classList.remove('is-active')

        const removeAllActive = () =>
          [...Array(sections.length).keys()].forEach((link) =>
            removeActive(link)
          )
        const sectionMargin = 0

        let currentActive = 0

        window.addEventListener('scroll', () => {
          const current =
            sections.length -
            [...sections]
              .reverse()
              .findIndex(
                (section) => window.scrollY >= section.offsetTop - sectionMargin
              ) -
            1

          if (current !== currentActive) {
            removeAllActive()
            currentActive = current
            makeActive(current)
          }
        })
      })
    }

    // aboutMenus.forEach((element) => {
    //   element.addEventListener('click', (event) => {
    //     event.preventDefault()
    //     aboutSection.value = element.dataset.section
    //     aboutForm.submit()
    //   })
    // })
  },
  finalize() {
    window.onload = () => {
      setTimeout(() => {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.charset = 'UTF-8'
        script.src =
          'https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js'
        script.dataset.domainScript = 'd2613450-6c53-486c-8123-102ac1d99082'
        script.dataset.documentLanguage = true
        document.getElementsByTagName('head')[0].appendChild(script)
      }, 2000)
    }

    enterView({
      selector: '.main-content',
      enter: (el) => {
        document.body.classList.add('header-sticky')
      },
      offset: 1,
      exit: (el) => {
        document.body.classList.remove('header-sticky')
      },
    })

    document.querySelector('#goTop').addEventListener('click', (event) => {
      event.preventDefault()
      const moveTo = new MoveTo()
      moveTo.move(document.body)
    })
  },
}
